import { typeCheckAppModule } from "../../../../core/utils";
import { NAME } from "./constants";
import { PaymentMethodProfilesPage } from "./PaymentMethodProfilesPage";

export const paymentMethodProfilesPage = typeCheckAppModule({
    NAME,
    Container: PaymentMethodProfilesPage,
});
